import { Link } from '@tanstack/react-router'
import { CatalogGridViewModel } from '@/components/catalog/catalog-grid/catalog-grid.view-model'
import { OccasionNavViewModel } from '@/components/occasion/occasion-page/components/occasion-nav/occasion-nav.view-model'
import type { useOccasionPageModel } from '@/components/occasion/occasion-page/occasion-page.model'
import { ContactCtaViewModel } from '@/components/shared/contact-cta/contact-cta.view-model'

type OccasionPageViewProps = ReturnType<typeof useOccasionPageModel>

export function OccasionPageView({
  occasion,
  products,
  isEmpty,
  gridContainerRef,
  otherOccasions,
}: OccasionPageViewProps) {
  return (
    <div className="fz-occasion-page">
      <header className="fz-occasion-page__header">
        <span className="fz-occasion-page__eyebrow">{occasion.title}</span>
        <h1 className="fz-occasion-page__headline">
          {occasion.emotionalHeadline}
        </h1>
        <p className="fz-occasion-page__description">{occasion.description}</p>
        <span className="fz-occasion-page__hairline" aria-hidden="true" />
      </header>
      <OccasionNavViewModel occasions={otherOccasions} />
      {isEmpty ? (
        <div className="fz-occasion-page__empty">
          <p className="fz-occasion-page__empty-text">
            Ainda não temos criações cadastradas para esta ocasião.
          </p>
          <Link to="/catalogo" className="fz-occasion-page__empty-link">
            Ver catálogo completo
          </Link>
        </div>
      ) : (
        <div ref={gridContainerRef} className="fz-occasion-page__grid">
          <CatalogGridViewModel products={products} />
        </div>
      )}
      <section className="fz-occasion-page__concierge">
        <div className="fz-occasion-page__concierge-inner">
          <h2 className="fz-occasion-page__concierge-title">
            Fale com uma florista de verdade.
          </h2>
          <p className="fz-occasion-page__concierge-sub">
            {occasion.conciergeSubcopy}
          </p>
          <ContactCtaViewModel label="Falar por e-mail" />
        </div>
      </section>
    </div>
  )
}
